import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAlert,{class:_vm.$style.alert,attrs:{"type":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.p_text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }